export default __webpack_public_path__ + "static/media/overlay-2.28db65d6.jpg";